export default __webpack_public_path__ + "static/media/flag-ru.84f9a94c.svg";